import { colors } from "@/styles/colors"
import * as React from "react"
import { SVGProps } from "react"

import { ReactComponent as LetalkInboxLogoSvg } from "@/assets/logos/letalk_inbox_logo.svg"

type LetalkLogoProps = SVGProps<SVGSVGElement> & {
	isDarkLogo?: boolean
}

const LetalkLogo: React.FC<LetalkLogoProps> = (props) => {
	const { isDarkLogo, style, ...svgProps } = props
	const fill = isDarkLogo ? colors.gray[800] : colors.gray[100]

	return (
		<LetalkInboxLogoSvg
			style={{ color: fill, ...style }}
			{...svgProps}
		/>
	)
}

export default LetalkLogo
